"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileManager = void 0;
var media_platform_1 = require("../../types/media-platform/media-platform");
var job_1 = require("./job/job");
var job_observable_1 = require("./job/job-observable");
var file_descriptor_1 = require("./metadata/file-descriptor");
var file_metadata_1 = require("./metadata/file-metadata");
var list_files_response_1 = require("./responses/list-files-response");
var upload_configuration_request_1 = require("./requests/upload-configuration-request");
/**
 * @param {Configuration} configuration
 * @param {HTTPClient} httpClient
 * @param {FileUploader} fileUploader
 * @doc FileManager
 */
var FileManager = /** @class */ (function () {
    function FileManager(configuration, httpClient, fileUploader, resumableUploader) {
        this.configuration = configuration;
        this.httpClient = httpClient;
        this.fileUploader = fileUploader;
        this.resumableUploader = resumableUploader;
        this.queueFileUpload = undefined;
        /**
         * @type {string}
         */
        this.baseUrl = 'https://' + configuration.domain;
        /**
         * @type {string}
         */
        this.apiUrl = this.baseUrl + '/_api/files';
    }
    /**
     * Get Upload Configuration
     * @param {IUploadConfigurationRequest} uploadConfigurationRequest
     * @returns {Promise<UploadConfigurationResponse>}
     * @example
     * fileManager.getUploadConfiguration({
     *   mimeType: 'image/gif',
     *   path: '/path/to',
     *   size: 12345, // in bytes
     *   acl: 'public'
     * }).
     * then(response => {
     *   console.log(response.uploadToken, response.uploadUrl)
     * });
     */
    FileManager.prototype.getUploadConfiguration = function (uploadConfigurationRequest) {
        return this.fileUploader.getUploadConfiguration(uploadConfigurationRequest);
    };
    /**
     * @description upload a file using the resumable TUS protocol
     * @param {string} path the destination to which the file will be uploaded
     * @param {string|Buffer|Stream} file can be one of: string - path to file, memory buffer, stream
     * @param {UploadFileRequest?} uploadFileRequest
     * @param {string?} uploadUrl
     * @returns {Promise<FileDescriptor[]>} a promise that resolves to an array of FileDescriptor
     *
     */
    FileManager.prototype.uploadFileResumable = function (path, file, uploadFileRequest, uploadUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var fileDescriptor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resumableUploader.uploadFile(path, file, uploadFileRequest, uploadUrl)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getFile(path)];
                    case 2:
                        fileDescriptor = _a.sent();
                        return [2 /*return*/, [fileDescriptor]];
                }
            });
        });
    };
    /**
     * @description upload a file
     * @param {string} path the destination to which the file will be uploaded
     * @param {string|Buffer|Stream} file can be one of: string - path to file, memory buffer, stream
     * @param {UploadFileRequest?} uploadFileRequest
     * @param {string?} uploadUrl
     */
    FileManager.prototype.uploadFile = function (path, file, uploadFileRequest, uploadUrl, callbackHandler) {
        var uploader;
        if ((uploadFileRequest === null || uploadFileRequest === void 0 ? void 0 : uploadFileRequest.protocol) === upload_configuration_request_1.UploadProtocol.TUS) {
            uploader = this.resumableUploader;
        }
        else {
            uploader = this.fileUploader;
        }
        var uploadFileResult = uploader.uploadFile(path, file, uploadFileRequest, uploadUrl, callbackHandler);
        // TODO: do it in a right way
        // Browser file uploader return `UploadJob` instead of promise
        if (!uploadFileResult.then) {
            return uploadFileResult;
        }
        return uploadFileResult.then(function (response) {
            return response;
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * import a file from a source URL, returns a Job Observable
     * @param importFileRequest
     * @returns {Observable<Job<FileImportSpecification>>}
     */
    FileManager.prototype.importFileObservable = function (importFileRequest) {
        var _this = this;
        return job_observable_1.observeJobCreator(this.configuration, this.httpClient)(function () { return _this.importFile(importFileRequest); });
    };
    /**
     * @description import a file from a source URL, returns a Job (see job manager)
     * @param {ImportFileRequest} importFileRequest
     * @returns {Promise<Job<FileImportSpecification>>}
     */
    FileManager.prototype.importFile = function (importFileRequest) {
        return this.httpClient
            .post(this.baseUrl + "/_api/import/file", importFileRequest)
            .then(function (response) {
            return new job_1.Job(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @description creates a file descriptor
     * @param {FileDescriptor} fileDescriptor
     * @returns {Promise<FileDescriptor>}
     */
    FileManager.prototype.createFile = function (fileDescriptor) {
        return this.httpClient
            .post(this.apiUrl, fileDescriptor)
            .then(function (response) {
            return new file_descriptor_1.FileDescriptor(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @description creates a folder descriptor, use this to create an empty directory
     * @param {FolderDescriptor} folderDescriptor
     * @returns {Promise<FileDescriptor>}
     */
    FileManager.prototype.createFolder = function (_a) {
        var acl = _a.acl, path = _a.path;
        return this.httpClient
            .post(this.apiUrl, {
            acl: acl,
            mimeType: media_platform_1.DescriptorMimeType.Folder,
            path: path,
            size: 0,
            type: media_platform_1.FileType.FOLDER,
        })
            .then(function (response) {
            return new file_descriptor_1.FileDescriptor(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {string} path
     */
    FileManager.prototype.getFile = function (path) {
        var params = {
            path: path,
        };
        return this.httpClient
            .get(this.apiUrl, params)
            .then(function (response) {
            return new file_descriptor_1.FileDescriptor(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {string} fileId
     * @returns {Promise<FileMetadata>}
     */
    FileManager.prototype.getFileMetadataById = function (fileId) {
        return this.httpClient
            .get(this.apiUrl + "/" + fileId + "/metadata")
            .then(function (response) {
            return new file_metadata_1.FileMetadata(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {string} path
     * @param {IListFilesRequest?} listFilesRequest
     */
    FileManager.prototype.listFiles = function (path, listFilesRequest) {
        var params = __assign({ path: path }, listFilesRequest);
        return this.httpClient
            .get(this.apiUrl + "/ls_dir", params)
            .then(function (response) {
            return new list_files_response_1.ListFilesResponse(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {string} path
     */
    FileManager.prototype.deleteFileByPath = function (path) {
        var params = {
            path: path,
        };
        return this.httpClient.delete(this.apiUrl, params).catch(function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {string} id
     */
    FileManager.prototype.deleteFileById = function (id) {
        return this.httpClient.delete(this.apiUrl + "/" + id).catch(function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {UpdateFileACL} params
     * @returns {Promise<FileDescriptor>}
     */
    FileManager.prototype.updateFileACL = function (params) {
        return this.httpClient
            .put(this.apiUrl, params)
            .then(function (response) {
            return new file_descriptor_1.FileDescriptor(response.payload);
        });
    };
    /**
     * @param {FileDescriptor} file
     * @param {ILifecycle} lifecycle
     * @returns {Promise<FileDescriptor>}
     */
    FileManager.prototype.addFileLifecycle = function (file, lifecycle) {
        return this.httpClient
            .post(this.apiUrl + "/lifecycle", {
            id: file.id,
            path: file.path,
            lifecycle: lifecycle,
        })
            .then(function (response) { return new file_descriptor_1.FileDescriptor(response.payload); });
    };
    /**
     * @param {string} fileId
     * @param {string} lifecycleId
     * @returns {Promise<FileDescriptor>}
     */
    FileManager.prototype.deleteFileLifecycle = function (fileId, lifecycleId) {
        return this.httpClient
            .delete(this.apiUrl + "/" + fileId + "/lifecycle/" + lifecycleId)
            .then(function (response) { return new file_descriptor_1.FileDescriptor(response.payload); });
    };
    FileManager.prototype.copyFile = function (copyFileRequest) {
        return this.httpClient
            .post(this.baseUrl + "/_api/copy/file", copyFileRequest)
            .then(function (response) { return new file_descriptor_1.FileDescriptor(response.payload); });
    };
    return FileManager;
}());
exports.FileManager = FileManager;
//# sourceMappingURL=file-manager.js.map